import { Component, OnInit, ElementRef } from '@angular/core';
import { UserProfileService } from '../core/userProfile.service';
import { MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { TableauReport, TableauService } from "../core/tableau.service";


@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.css"],
})
export class ReportComponent implements OnInit {

  viz: any;
  public searchItem: string;
  public workbookName: string;
  public allWorkBooks: any;
  public modifiedAllWorkBooks = [];
  public isSelected: string;
  public selectedWorkBookId: string;
  public selectedWorkBook: any;
  selected=0;
  public loaded = false;
  public isWorkBookSelected = false;
  public dashboard: TableauReport;
  public workBookTitle: string;
  public contentUrl: string;
  public tableauServer: string;


  constructor(
    private userProfileService: UserProfileService,
    public dialog: MatDialog,
    private tableauService: TableauService,
    private router: Router,
    public elm: ElementRef,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  public async ngOnInit() {
    this.initTableau();
  }

  async initTableau() {
    this.loadWorkBooks('');
    this.dashboard = await this.tableauService.getUserDashboard(this.userProfileService.userEmail);
    this.tableauServer = await this.tableauService.getServerURI();
  }   

  async loadWorkBooks(filter){
    this.loaded = false;
    this.allWorkBooks = await this.tableauService.loadWorkBooks(filter);
    this.loaded = true;
  }

  getWorkbooks() {
    this.loadWorkBooks(this.searchItem);
  }


  async select(workBookId){
    const selectedWorkBook = this.allWorkBooks.find( x => x.workBookId === workBookId );

    if ( selectedWorkBook.customReportUrl ){
      this.router.navigate( ["/reportpdf", selectedWorkBook.workBookId] );
    }
    else {
      this.workBookTitle = selectedWorkBook.workbookName;
      localStorage.setItem('reportname', this.workBookTitle);
      if (selectedWorkBook.workbookViews.view && selectedWorkBook.workbookViews.view[0].view.contentUrl){
        this.contentUrl = selectedWorkBook.workbookViews.view[0].view.contentUrl.replace('/sheets','');
      }
      else if(selectedWorkBook.workbookViews.view[0].view[0]){
        this.contentUrl = selectedWorkBook.workbookViews.view[0].view[0].contentUrl.replace('/sheets',''); 
      }
      const navigationDetails: string[] = ['/report/reportpreview', `${selectedWorkBook.workBookId}`];
      this.router.navigate(navigationDetails);
    }
  }




}
